import { jsx as _jsx } from "react/jsx-runtime";
import * as Sentry from '@sentry/react';
import { Suspense } from 'react';
import { createBrowserRouter } from 'react-router-dom';
import LoadingSpinner from '~/components/layout/LoadingSpinner';
import DashboardLayout from '~/layout/dashboard/DashboardLayout';
import ProtectedLayout from '~/layout/ProtectedLayout';
import RootLayout from '~/layout/RootLayout';
import ChatRoutes from '~/modules/chat/routes/ChatRoutes';
import DashboardScreen from '~/modules/dashboard/DashboardScreen';
import AppCrash from '~/modules/error/AppCrash';
import InvalidRoute from '~/modules/error/InvalidRoute';
import LoginScreen from '~/modules/login/LoginScreen';
import PhotoManagerRoutes from '~/modules/photos/routes/PhotoManagerRoutes';
import ScanRoutes from '~/modules/scans/routes/ScanRoutes';
import WorkshopRoutes from '~/modules/workshop/routes/WorkshopRoutes';
const sentryCreateBrowserRouter = Sentry.wrapCreateBrowserRouter(createBrowserRouter);
const router = sentryCreateBrowserRouter([
    {
        path: '/',
        errorElement: _jsx(AppCrash, {}),
        element: (_jsx(Suspense, { fallback: _jsx(LoadingSpinner, {}), children: _jsx(RootLayout, {}) })),
        children: [
            {
                element: _jsx(ProtectedLayout, {}),
                children: [
                    {
                        element: _jsx(DashboardLayout, {}),
                        children: [
                            {
                                path: '/',
                                element: _jsx(DashboardScreen, {}),
                            },
                        ],
                    },
                    ...ChatRoutes,
                    ...PhotoManagerRoutes,
                    ...ScanRoutes,
                    ...WorkshopRoutes,
                ],
            },
            {
                path: '/login',
                element: _jsx(LoginScreen, {}),
            },
            {
                path: '/session-expired',
                element: _jsx(AppCrash, {}),
            },
        ],
    },
    {
        path: '*',
        element: _jsx(InvalidRoute, {}),
    },
]);
export default router;
